import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "../../pages/jck/Jck.module.css";

function getTimeRemaining(targetDate) {
  const total = targetDate - new Date();
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));
  return { total, days, hours, minutes, seconds };
}

const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState(getTimeRemaining(targetDate));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeRemaining(targetDate));
    }, 1000);
    return () => clearInterval(timer);
  }, [targetDate]);

  if (timeLeft.total <= 0) {
    return <span className={styles.countdownCardNumber}>Event Started!</span>;
  }

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <div className={`${styles.countdownCard} ${styles.countdownCardDays}`}>
        <span>{timeLeft.days}</span>
        <span className={styles.countdownCardUnit}>Days</span>
      </div>
      <div className={styles.countdownTimer}>
        <div className={styles.countdownCard}>
          <span className={styles.countdownCardNumber}>
            {String(timeLeft.hours).padStart(2, "0")}
          </span>
          <span className={styles.countdownCardUnit}>Hours</span>
        </div>
        <div className={styles.countdownCard}>
          <span className={styles.countdownCardNumber}>
            {String(timeLeft.minutes).padStart(2, "0")}
          </span>
          <span className={styles.countdownCardUnit}>Minutes</span>
        </div>
        <div className={styles.countdownCard}>
          <span className={styles.countdownCardNumber}>
            {String(timeLeft.seconds).padStart(2, "0")}
          </span>
          <span className={styles.countdownCardUnit}>Seconds</span>
        </div>
      </div>
    </div>
  );
};

CountdownTimer.propTypes = {
  targetDate: PropTypes.instanceOf(Date).isRequired,
};

export default CountdownTimer;
